export default __webpack_public_path__ + "static/media/appointment widget.adeb6339.png";